export enum DocumentSource {
    CUSTOMER = 'CUSTOMER',
    VISIT = 'VISIT',
    RESERVATION = 'RESERVATION',
    TRIAGE = 'TRIAGE',
    CASE = 'CASE',
    NETWORK = 'NETWORK',
}
